/** @format */

import React from 'react';
import TemplateButton from './TemplateButton.js';
import PropTypes from 'prop-types';
import { ReactComponent as Trash } from '../../assets/themes/OPL/img/icons/Trash.svg';

function DeleteButton({ ...props }) {
    const { classes, callback, callbackParam, color, text, ...rest } = props;
    return (
        <TemplateButton
            {...rest}
            className={classes}
            classes={classes}
            icon={Trash}
            color={color}
            callback={callback}
            callbackParam={callbackParam}
            text={text}
        />
    );
}

DeleteButton.propTypes = {
    callback: PropTypes.func.isRequired,
    callbackParam: PropTypes.object.isRequired,
    color: PropTypes.string,
    text: PropTypes.string,
};

export default DeleteButton;
